import { RootState } from "../../../../../redux/store";
import * as constants from "./constants";

export const isItemsLoading = (state:RootState) => state.taskCategories.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.taskCategories.actionsLoading;
export const getItems = (state:RootState) => state.taskCategories.items;
export const getItemsSelect = (state:RootState) => state.taskCategories.dropDownItems;
export const getItemsCount = (state:RootState) => state.taskCategories.itemsCount;
export const getItemForEdit = (state:RootState) => state.taskCategories.itemForEdit;
export const getError = (state:RootState) => state.taskCategories.error;
export const getErrorAction = (state:RootState) => state.taskCategories.errorAction;
export const validationErrors = (state:RootState) => state.taskCategories.validationErrors;

export const getTaskCategoryTypes = (state:RootState) => state.taskCategories[constants.TASKCATEGORY_TYPES];
export const getTaskCategoryTypesLoading = (state:RootState) => state.taskCategories[constants.TASKCATEGORY_TYPES_LOADING];
